(function () {
  'use strict';

  var root = document.querySelector('[data-service]');
  if (!root) return;

  var hub = root.querySelector('[data-service-hub]');
  var topics = Array.prototype.slice.call(root.querySelectorAll('[data-service-topic]'));
  var links = Array.prototype.slice.call(root.querySelectorAll('[data-service-link]'));
  var back = root.querySelector('[data-service-back]');
  var title = root.querySelector('[data-service-title]');
  var crumb = root.querySelector('[data-service-crumb]');
  var body = root.querySelector('[data-service-body]');
  if (!hub || !topics.length || !title || !body) return;

  var hubTitle = title.textContent;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function topicIdFrom(value) {
    var raw = String(value || '');
    var hashIndex = raw.lastIndexOf('#');
    if (hashIndex >= 0) return raw.slice(hashIndex + 1);
    return raw.replace(/^#/, '');
  }

  function topicFor(hash) {
    var id = topicIdFrom(hash);
    if (!id) return null;
    for (var i = 0; i < topics.length; i++) {
      if (topics[i].getAttribute('data-service-topic') === id) return topics[i];
    }
    return null;
  }

  // profuomo swaps views client-side; the small fade-and-rise matches both
  // their feel and the theme's opacity+translate motion rule.
  function animateIn() {
    if (reduced.matches) return;
    body.classList.remove('is-entering');
    void body.offsetWidth;
    body.classList.add('is-entering');
  }

  function show(hash, moveFocus) {
    var topic = topicFor(hash);

    hub.hidden = !!topic;
    topics.forEach(function (article) {
      article.hidden = article !== topic;
    });

    links.forEach(function (link) {
      var isActive;
      if (link.hasAttribute('data-service-home')) {
        isActive = !topic;
      } else {
        isActive = topic && topicIdFrom(link.getAttribute('href')) === topic.getAttribute('data-service-topic');
      }
      link.classList.toggle('is-active', !!isActive);
    });

    if (back) back.hidden = !topic;
    title.textContent = topic ? topic.getAttribute('data-service-label') : hubTitle;
    if (crumb) {
      crumb.textContent = topic ? topic.getAttribute('data-service-label') : '';
      crumb.hidden = !topic;
      var sep = root.querySelector('[data-service-crumb-sep]');
      if (sep) sep.hidden = !topic;
    }

    animateIn();

    var activeLink = root.querySelector('.main-service__topic-link.is-active');
    if (activeLink && activeLink.scrollIntoView) {
      activeLink.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduced.matches ? 'auto' : 'smooth' });
    }

    if (moveFocus) {
      title.setAttribute('tabindex', '-1');
      title.focus({ preventScroll: true });
      window.scrollTo({ top: 0, behavior: reduced.matches ? 'auto' : 'smooth' });
    }
  }

  root.addEventListener('click', function (event) {
    var link = event.target.closest('[data-service-link], [data-service-back]');
    if (!link) return;
    event.preventDefault();
    var target = link.getAttribute('href') || '';
    if (target === '#' || link.hasAttribute('data-service-back') || link.hasAttribute('data-service-home')) {
      history.pushState(null, '', location.pathname + location.search);
      show('', true);
    } else {
      var id = topicIdFrom(target);
      history.pushState(null, '', id ? '#' + id : location.pathname + location.search);
      show(id ? '#' + id : '', true);
    }
  });

  window.addEventListener('popstate', function () {
    show(location.hash, false);
  });

  window.addEventListener('hashchange', function () {
    show(location.hash, false);
  });

  root.setAttribute('data-service-ready', '');
  show(location.hash, false);
})();
